export class AppEnvironment {

    public AzureTenantID: string = null;
    public AzureClientID: string = null;
    
    constructor() {
  
      const configs = sessionStorage.getItem("_MRVPAG_CONFIGS_");
  
      if(configs){
        const _configs = JSON.parse(atob(configs));
        this.AzureClientID = _configs.azure_client_id;
        this.AzureTenantID = _configs.azure_tenant_id;
      }
    }
  
    public static set(config: any): void {
      sessionStorage.setItem('_MRVPAG_CONFIGS_', btoa(JSON.stringify(config)));
    }
  }
  